// Determine si le bot doit dire bonsoir et ou bonjour en fonction de l'heure
export const isNight = () => {
	let currentDate = new Date();
	let hour = currentDate.getHours();
	let time = hour;
	if(time>16 || time<7) return true;
	return false;
};